"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _autoBind = _interopRequireDefault(require("auto-bind"));

var _marshaler = _interopRequireDefault(require("../util/marshaler"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var DeviceClaim = /*#__PURE__*/function () {
  function DeviceClaim(registry, _ref) {
    var stackConfig = _ref.stackConfig;
    (0, _classCallCheck2["default"])(this, DeviceClaim);
    this._api = registry;
    this._stackConfig = stackConfig;
    (0, _autoBind["default"])(this);
  } // Claim


  (0, _createClass2["default"])(DeviceClaim, [{
    key: "claim",
    value: function () {
      var _claim = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(applicationId, qrCode, values) {
        var deviceToClaim, payload, response;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                deviceToClaim = qrCode ? {
                  qr_code: qrCode
                } : values;
                payload = _objectSpread(_objectSpread({}, deviceToClaim), {}, {
                  target_application_ids: {
                    application_id: applicationId
                  }
                });
                _context.next = 4;
                return this._api.EndDeviceClaimingServer.Claim(undefined, payload);

              case 4:
                response = _context.sent;
                return _context.abrupt("return", _marshaler["default"].payloadSingleResponse(response));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function claim(_x, _x2, _x3) {
        return _claim.apply(this, arguments);
      }

      return claim;
    }()
  }, {
    key: "GetInfoByJoinEUI",
    value: function () {
      var _GetInfoByJoinEUI = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(join_eui) {
        var response;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._api.EndDeviceClaimingServer.GetInfoByJoinEUI(undefined, join_eui);

              case 2:
                response = _context2.sent;
                return _context2.abrupt("return", _marshaler["default"].payloadSingleResponse(response));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function GetInfoByJoinEUI(_x4) {
        return _GetInfoByJoinEUI.apply(this, arguments);
      }

      return GetInfoByJoinEUI;
    }()
  }]);
  return DeviceClaim;
}();

var _default = DeviceClaim;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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